"use client";

import { usePathname } from "next/navigation";
import { QuickMenu } from "@kkeut/ui/quick-menu";
import { useLocale } from "@/components/LocaleProvider";
import { withLocaleHref } from "@/lib/locale-url";
import { isMemberPreviewPath } from "@kkeut/lib/member-preview-route";
import { branchConfig } from "@/config/branch";

export function FloatingQuickMenu({ initialInfo }) {
  const { locale } = useLocale();
  const pathname = usePathname();
  // QuickMenu 는 두 방식을 다 받는다 — initialInfo 가 있으면 fetch 하지 않고,
  // 없으면 branchId 로 직접 읽는다. 구로만 SSR 로 미리 넘긴다 (#869).
  return (
    <QuickMenu
      branchId={branchConfig.branchId}
      initialInfo={initialInfo}
      aboutHref={withLocaleHref("/about/kkeut", locale)}
      hidden={isMemberPreviewPath(pathname)}
    />
  );
}
